var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_49_16981)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#363638"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5547L15.6855 17.48C15.7826 17.5294 15.8905 17.5552 16 17.5552C16.1095 17.5552 16.2174 17.5294 16.3145 17.48L26 12.5556V21.1111C26 21.849 25.7113 22.559 25.193 23.0953C24.6747 23.6317 23.9662 23.9538 23.2127 23.9956L23.0455 24H8.95455C8.19987 24 7.47379 23.7177 6.92524 23.211C6.3767 22.7042 6.04727 22.0114 6.00455 21.2747L6 21.1111V12.5547ZM8.95455 8H23.0455C23.8001 7.99995 24.5262 8.28227 25.0748 8.78904C25.6233 9.29581 25.9527 9.98862 25.9955 10.7253L26 10.8889V11.0524L16 16.1369L6 11.0524V10.8889C5.99995 10.151 6.28869 9.44104 6.80697 8.90468C7.32526 8.36833 8.03381 8.04622 8.78727 8.00444L8.95455 8H23.0455H8.95455Z",
    fill: "#E72D38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_49_16981",
    x: -6,
    y: -6,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_49_16981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_49_16981",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBg);
export default __webpack_public_path__ + "static/media/mailBg.20d166b0cd4dc922a22b0e89dfbbed06.svg";
export { ForwardRef as ReactComponent };